import axios from 'axios';
import _ from 'lodash';
import sha1 from 'js-sha1';
import { SubmissionError } from 'redux-form';

import { ORDER_CONF_EMAIL_SEND_SUCCESS } from './types';

const emarsysEndpoint = 'https://api.emarsys.net/api/v2/event/1732/trigger';
const emarsysAPIUser = 'dummy_user';
const emarsysAPIToken = 'example_token';

export const successfulSend = em => ({
  type: ORDER_CONF_EMAIL_SEND_SUCCESS,
  payload: em,
});

const populateJson = (toEmail, state) => {
  return {
    key_id: 3,
    external_id: toEmail,
    data: {
      global: {
        order: {
          orderNumber: state.orders.currentOrder,
          orderDate: new Date().toLocaleDateString('en-us'),
          billingAddress: state.userInfo.customer.billingAddress,
          shippingAddress: state.userInfo.customer.shippingAddress,
          payment: {
            lastFour: state.userInfo.defaultPaymentOption.creditCardNumber.slice(
              -4
            ),
          },
          entries: [
            {
              productName: state.userInfo.product.productName,
              sku: state.userInfo.product.sku,
              quantity: state.userInfo.product.quantity,
              subtotal: state.userInfo.priceInformation.price,
            },
          ],
          price: {
            subtotal: state.userInfo.priceInformation.price,
            shipping: state.userInfo.priceInformation.shipping,
            tax: state.userInfo.priceInformation.tax,
            total:
              state.userInfo.priceInformation.tax +
              state.userInfo.priceInformation.shipping +
              state.userInfo.priceInformation.price,
          },
        },
        customer: {
          email: toEmail,
          pharmacyType:
            state.userInfo.product.productCompoundAttributeSubsidiaryBrand,
        },
      },
    },
  };
};

const populateAuthHeader = () => {
  const nonce = _.times(32, () => _.random(15).toString(16)).join('');
  const timestamp = new Date().toISOString();

  const preDigest = `${nonce}${timestamp}${emarsysAPIToken}`;
  const digest = btoa(sha1.create(preDigest).hex());

  return {
    'X-WSSE': `X-WSSE: UsernameToken Username="${emarsysAPIUser}", PasswordDigest="${digest}", Nonce="${nonce}", Created="${timestamp}"`,
    'Access-Control-Allow-Origin': '*',
  };
};

const sendOrderConfEmail = () => (dispatch, getState) => {
  const state = getState();
  const email = state.form.OrderConfEmailForm.values.emailAddress;

  const postJson = populateJson(email, state);
  const headerJson = populateAuthHeader();

  /* [apk] todo: remove below */
  console.log(postJson);
  if (_.includes(email, 'pass')) {
    dispatch(successfulSend({}));
    return {};
  } else if (_.includes(email, 'fail')) {
    throw new SubmissionError({
      emailAddress: 'There was an error sending your email.',
    });
  }
  // end of removal req'd

  return axios
    .post(emarsysEndpoint, postJson, { headers: headerJson })
    .then(response => {
      dispatch(successfulSend(response));
    })
    .catch(error => {
      if (error instanceof SubmissionError) {
        throw new SubmissionError(error.errors);
      } else {
        throw new SubmissionError({
          emailAddress: 'There was an error sending your email.',
        });
      }
    });
};

export default sendOrderConfEmail;



// WEBPACK FOOTER //
// ./src/actions/userInformation/orderConfEmail.js